import axios from 'axios';
import { apiUrl } from '../config/config.js';

const BASE_URL = apiUrl;
// Create axios instance with default config
const api = axios.create({
  baseURL: BASE_URL,
});

// Interceptor to add auth token and proper headers to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  
  // Add token if it exists
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Set proper content type for form data
  if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  } else {
    config.headers['Content-Type'] = 'application/json';
  }
  
  return config;
});

export const tenderApi = {
  // Get all tenders
  getAllTenders: async () => {
    try {
      const response = await api.get('admin/tenders');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch tenders');
    }
  },

  // Get single tender by ID
  getTenderById: async (id) => {
    try {
      const response = await api.get(`admin/tender/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch tender');
    }
  },

  // Create new tender
  createTender: async (tenderData) => {
    try {
      console.log(tenderData);  
      const response = await api.post('admin/add-tender', tenderData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create tender');
    }
  },

  // Update tender
  updateTender: async (id, tenderData) => {
    try {
      const response = await api.put(`admin/tender/${id}`, tenderData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update tender');
    }
  },

  // Delete tender
  deleteTender: async (id) => {
    try {
      const response = await api.delete(`admin/tender/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete tender');
    }
  },

  // Search tenders
  searchTenders: async (searchQuery) => {
    try {
      const response = await api.get(`admin/tenders/search`, {
        params: { q: searchQuery }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to search tenders');
    }
  }
};

export default tenderApi;
